"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var renderer_1 = require("./renderer");
var EventReflect;
(function (EventReflect) {
    EventReflect["onFocus"] = "focus";
    EventReflect["onBlur"] = "blur";
})(EventReflect || (EventReflect = {}));
function hasEventUpdate(currProps, nextProps) {
    var onFocus = nextProps.onFocus, onBlur = nextProps.onBlur, disable = nextProps.disable;
    if (onFocus === currProps.onFocus && onBlur === currProps.onBlur && disable === currProps.disable) {
        return false;
    }
    return true;
}
function hasConfigUpdate(currProps, nextProps, adapter) {
    // TODO: 改成取configurator.configuration
    var hasUpdate = currProps.keepLastLine === nextProps.keepLastLine &&
        currProps.spellCheck === nextProps.spellCheck &&
        currProps.keepWhiteSpace === nextProps.keepWhiteSpace &&
        currProps.placeholder === nextProps.placeholder &&
        currProps.onError === nextProps.onError;
    if (hasUpdate && adapter)
        updateConfig(adapter, nextProps);
    return hasUpdate;
}
function updateConfig(adapter, newConfig) {
    adapter.configurator.updateConfig(newConfig);
}
function init(mount, config, extra) {
    var spellCheck = extra.spellCheck, placeholder = extra.placeholder, locale = extra.locale, onError = extra.onError, basicControls = __rest(extra, ["spellCheck", "placeholder", "locale", "onError"]);
    var configurator = new core_utilities_1.SylConfigurator(mount, config.Plugins, __assign({ placeholder: placeholder,
        spellCheck: spellCheck,
        locale: locale,
        onError: onError }, basicControls));
    var adapter = new core_utilities_1.SylApi(configurator, {
        modules: config.Modules
    });
    renderer_1.rendererGlobalCache.add(adapter);
    mountEvent(adapter, {
        onBlur: extra.onBlur,
        onFocus: extra.onFocus
    });
    return adapter;
}
function mountEvent(adapter, eventMap, preEventList) {
    if (preEventList === void 0) { preEventList = {}; }
    Object.keys(eventMap).forEach(function (eventName) {
        var handler = eventMap[eventName];
        var prevHandler = preEventList[eventName];
        if (!EventReflect[eventName])
            return;
        if (prevHandler !== handler) {
            var localEvent = EventReflect[eventName];
            if (prevHandler)
                adapter.off(localEvent, prevHandler);
            if (handler)
                adapter.on(localEvent, handler);
        }
    });
}
var SylEditorService = {
    EventChannel: core_utilities_1.EventChannel,
    hasEventUpdate: hasEventUpdate,
    hasConfigUpdate: hasConfigUpdate,
    updateConfig: updateConfig,
    init: init,
    mountEvent: mountEvent
};
exports.SylEditorService = SylEditorService;
//# sourceMappingURL=Editor.js.map